import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const fadeUp = {
    initial: { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-50px' },
    transition: { duration: 0.6, ease: 'easeOut' },
};

export function CredibilitySnapshot() {
    return (
        <section data-testid="credibility-section" className="bg-white py-24 md:py-32">
            <div className="max-w-4xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp}>
                    <p className="text-gold-400 text-xs font-bold tracking-[0.3em] uppercase font-inter mb-4">
                        Built by an Operator, Not an Agency
                    </p>
                    <h2 className="font-montserrat font-bold text-4xl md:text-5xl text-navy-900 mb-6 tracking-tight">
                        This System Runs a Real Real Estate Business. Right Now.
                    </h2>
                    <p className="text-[#6B7280] text-lg leading-relaxed mb-8">
                        Adam Cothes sells $50-70M a year on the Eastside Seattle market. He runs his entire operation with 3 VAs, works about 35 hours a week, and has been refining this system for over a decade under real pressure. The program your VA will run on is the same one running his business today.
                    </p>
                    <div className="bg-[#F8F9FA] border-l-4 border-gold-400 rounded-sm p-8 mb-10">
                        <p className="text-navy-900 text-lg leading-relaxed italic font-medium">
                            "If you want cheap labor, this isn't the model. If you want leverage, continuity, and reduced risk - this is what it was built for."
                        </p>
                    </div>
                    <Link
                        to="/about"
                        className="inline-block border border-navy-900 text-navy-900 px-8 py-3.5 rounded-sm text-sm font-semibold tracking-wide hover:bg-navy-900 hover:text-white transition-colors duration-200"
                        data-testid="credibility-cta"
                    >
                        Read Adam's Story
                    </Link>
                </motion.div>
            </div>
        </section>
    );
}
